var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v("Actualizar rol y permiso"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.UPDATE()
                      },
                    },
                  },
                  [
                    _vm.count == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Guardar cambios")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c("div", { staticClass: "container-fluid vstack gap-5" }, [
          _vm.loading
            ? _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "spinner-border text-primary",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  ),
                ]),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c("div", [
                    _c("label", { staticClass: "input-title" }, [
                      _vm._v("Nombre"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "form-control form-control-sm readonly" },
                      [_vm._v(_vm._s(_vm.data.name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "input-title" }, [
                        _vm._v("Icono"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.icon,
                            expression: "data.icon",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.icon ? "is-invalid" : "",
                        attrs: { type: "text" },
                        domProps: { value: _vm.data.icon },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.data, "icon", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.icon, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "input-title" }, [
                        _vm._v("Descripción"),
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.data.description,
                            expression: "data.description",
                          },
                        ],
                        staticClass: "form-control form-control-sm",
                        class: _vm.errors.description ? "is-invalid" : "",
                        attrs: { rows: "5" },
                        domProps: { value: _vm.data.description },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.data,
                              "description",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.errors.description, function (error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "invalid-feedback" },
                          [_vm._v(_vm._s(error))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "list-group list-group-flush gap-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "list-group-item p-6 bg-white border rounded-2",
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "w-10" }, [
                              _c("i", {
                                staticClass: "bi bi-people text-lg text-muted",
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-1 me-10" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "d-block h5 text-primary-hover",
                                },
                                [_vm._v("Permisos")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticClass: "mt-1 text-sm text-muted mb-0" },
                                [
                                  _vm._v(
                                    "Seleccione los permisos que desea\n                                            agregar."
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "vstack gap-2 mt-3 ms-10" },
                            [
                              _c("v-treeview", {
                                attrs: {
                                  items: _vm.permissions,
                                  open: _vm.open,
                                  selectable: "",
                                  "open-on-click": "",
                                  "item-key": "id",
                                  dense: "",
                                },
                                on: {
                                  "update:open": function ($event) {
                                    _vm.open = $event
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var open = ref.open
                                      return [
                                        _c("i", {
                                          class: item.file,
                                          staticStyle: { "font-size": "12px" },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.data.treeview,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data, "treeview", $$v)
                                  },
                                  expression: "data.treeview",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }